// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
import Original from 'lucide-react/dist/esm/icons/bug.js';

import { paths } from '../generated/bug';
import { makeBrandedIcon } from '../make-branded';

export default makeBrandedIcon('bug', Original, paths);
